import { createContext } from 'react'
import type { ThemeProviderState } from '@/components/theme/types'

const initialState: ThemeProviderState = {
  theme: 'system',
  setTheme: () => null,
}

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialState)
